import { CanvasQueryParams } from '~/constants/canvasQueryParams';
import { getPrivateCanvasIdFromPath } from '~/utils/PathUtils';

export const getCanvasIdFromHref = (href: string) => {
  const [pathname = '', search = ''] = href.split('#')[0].split('?');

  return getPrivateCanvasIdFromPath(pathname) ?? new URLSearchParams(search).get(CanvasQueryParams.canvasId);
};
